import { render } from "./ChatInputText.vue?vue&type=template&id=1bd54c9f&scoped=true&ts=true"
import script from "./ChatInputText.vue?vue&type=script&lang=ts"
export * from "./ChatInputText.vue?vue&type=script&lang=ts"

import "./ChatInputText.vue?vue&type=style&index=0&id=1bd54c9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd54c9f"]])

export default __exports__